/* =========================================================================
   Pellington - swipeable product-card images. Change A, 8 September 2026.

   This file has exactly one job: move the progress-bar fill. The gesture,
   the snapping, and tap-vs-swipe are all native browser behaviour - see
   assets/pell-card-swipe.css. Hand-rolled gesture code is where this
   feature normally fails, so there is none here.

   NO requestAnimationFrame. The first draft throttled through rAF, which
   looked correct and measured correct on a visible page - and never ran at
   all when document.hidden was true, because browsers stop serving frames
   to a hidden tab. That left the bar stale on a restored or backgrounded
   tab until the next scroll. The work is two getBoundingClientRect calls on
   an element whose size a scroll does not dirty, so it is done inline and
   the whole queue-and-flush apparatus is gone with it.
   ========================================================================= */
(function () {
  'use strict';

  window.__pellSwipeJs = true; /* read by the ?swipedebug=1 panel */

  /* Which slide is showing, measured geometrically: the slide with the
     largest overlap with the track's own box wins.

     Deliberately NOT scrollLeft. Measured on this theme, 8 Sep: on /ar-ae
     the same one-slide swipe reports scrollLeft 0 -> -166, where English
     reports 0 -> +166. That sign flip is engine-dependent, and it is risk
     #4 - the classic "works in English, broken in Arabic". Bounding boxes
     read the same in both directions, so this function never needs to know
     which way the page runs. */
  function update(track) {
    var wrapper = track.parentElement;
    if (!wrapper) return;
    var bar = wrapper.querySelector('.pell-swipe__bar');
    if (!bar) return;

    var tr = track.getBoundingClientRect();
    var slides = track.children;
    var best = 0;
    var bestOverlap = -1;

    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      var overlap = Math.min(r.right, tr.right) - Math.max(r.left, tr.left);
      if (overlap > bestOverlap) {
        bestOverlap = overlap;
        best = i;
      }
    }

    var v = String(best);
    if (bar.getAttribute('data-i') !== v) bar.setAttribute('data-i', v);
  }

  /* Scroll events do not bubble, but they DO capture. One listener on the
     document therefore catches every card track on the page, including the
     cards infinite scroll injects after load - risk #5 - without ever
     initialising anything per card, and without a MutationObserver. */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.classList) return;
    if (!t.classList.contains('pell-swipe')) return;
    update(t);
  }, true);

  /* A rotation can leave a track between snap points. Cheap, and rare. */
  window.addEventListener('resize', function () {
    var tracks = document.querySelectorAll('.pell-swipe');
    for (var i = 0; i < tracks.length; i++) update(tracks[i]);
  }, { passive: true });
})();
